// extracted by mini-css-extract-plugin
module.exports = {"root":"E02kqErK0XxOnT46TwrI"};